import BaseValidator from '~/composer/composer/lib/validation/BaseValidator';

export default class LinkedInValidator extends BaseValidator {}
